import request from 'utils/RequestManager';

import config from '../../../../../config';

const backendURL = config.BACKEND_HOST;

export default function getHistoryPage(options) {
  return request({
    method: 'POST',
    baseURL: backendURL,
    url: '/history',
    data: options,
  })
    .then(response => response.data);
}



// WEBPACK FOOTER //
// ./src/scenes/dashboard/components/management/history/api.js